export const NAME = 'PregnancyModal';
export const TITLE = 'Keep in mind...';
export const NEW_TITLE =
  'Disability coverage options and window to apply are limited during pregnancy';
export const CONTENT =
  'Individual disability insurance does NOT pay out benefits for normal maternity leave.';
export const NEW_CONTENT = [
  'The insured must secure coverage before the 3rd trimester. If not, they will have to wait until after maternity leave ends and they return to work full-time.',
  'Disability insurance does not cover maternity leave.',
];
export const ELIGIBILITY_NOTE =
  "You're eligible to apply for coverage until the end of your second trimester, but your current pregnancy will likely be excluded from the final policy.";
